import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "@reach/router";
import Header from "./Header";
import Footer from "./Footer";
import * as topStyles from "./../styles/page/top.module.scss";

export interface LayoutProps {
	children: any;
}

const Layout: React.FunctionComponent<LayoutProps> = (props) => {
	const { children } = props;
	const location = useLocation();
	const pageCategory = location.pathname.split('/')[1];
	const isTop = !pageCategory;

	const fhRef = useRef<HTMLDivElement>(null);
	const [isNavOpen, setIsNavOpen] = useState(false);

	useEffect(() => {
		const onScroll = function () {
			if (window.scrollY > 300 || isNavOpen) {
				fhRef?.current?.classList.add('is-show');
			} else {
				fhRef?.current?.classList.remove('is-show');
			}
		}
		// 初回実行(ページがすでにスクロールされている場合に対応)
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => {
			// スクロールイベントリスナーを取り外す
			window.removeEventListener('scroll', onScroll);
		}
	}, [isNavOpen]);

	return (
				<>
					<div className={`overlay__fh sp-only${isNavOpen ? ` is-show` : ``}`}></div>
					<header id="global__header" className={isTop ? "top-header" : ""}>
						<Header isFhNavOpen={isNavOpen} setIsFhNavOpen={setIsNavOpen} isFixedHeader={false}></Header>
					</header>
					<div ref={fhRef} id="fixed__header">
						<Header isFhNavOpen={isNavOpen} setIsFhNavOpen={setIsNavOpen} isFixedHeader={true}></Header>
					</div>
						<main className={isTop ? `${topStyles.top_main}` : `${pageCategory}_main`}>{children}</main>
					<footer id="global__footer">
						<Footer></Footer>
					</footer>
				</>
	);
}

export default Layout;